// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-sidebar .streams-drawer-sidebar-header {
  color: #4E495C;
}
.streams-drawer-sidebar cu-icon[name="new-feature-lg"] .cu-icon-lg {
  fill: #00c9b1;
  width: 20px;
  height: 20px;
}
.streams-drawer-sidebar .streams-list {
  max-width: 232px;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-sidebar/streams-drawer-sidebar.less"],"names":[],"mappings":"AAMA;EAGQ,cAAA;AAPR;AAIA;EAOQ,aAAA;EACA,WAAA;EACA,YAAA;AARR;AADA;EAaQ,gBAAA;AATR","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n\n@import (reference) '../../../css/unison';\n\n.streams-drawer-sidebar {\n\n    .streams-drawer-sidebar-header {\n        color: @cu-gray-9;\n    }\n\n    cu-icon[name=\"new-feature-lg\"] .cu-icon-lg {\n        fill: @cu-mint-5;\n        width: 20px;\n        height: 20px;\n    }\n\n    .streams-list {\n        max-width: @cu-small-measure;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
